<footer class="clearfix" role="contentinfo">
  <div class="container-fluid">
    <div class="col-sm-11 center-block">
      <div class="float-start" tabindex="0">
        <b>Reed Tech SingleSource&trade; for Drug Products v5.2</b>&nbsp;&nbsp;Copyright © {{currentYear}} Reed
        Technology and Information Services Inc.
      </div>
      <ul class="float-end footerLinks" role="list">
        <li *ngIf='lastLogonDate' role="listitem"> <a href="#" role="link" aria-label="last sign-in"> Last sign-in: {{lastLogonDate | utcToLocale}}</a>&nbsp;|&nbsp;</li>
        <li role="listitem"> <a href="https://www.lexisnexis.com/terms/" target="_blank" role="link" aria-label="terms and conditions">Terms &amp; Conditions</a>&nbsp;|&nbsp;</li>
        <li role="listitem">
          <a href="http://www.lexisnexis.com/en-us/terms/privacy-policy.page" target="_blank" role="link" aria-label="privacy policy">Privacy Policy</a>&nbsp;|&nbsp;
        </li>
        <li role="listitem">
          <a href="javascript: void(0);" id="ot-sdk-btn" class="ot-sdk-show-settings">Cookies Settings</a>
        </li>
        <li role="listitem">
          <img src="../../../../assets/images/relxgroupLogo2017sm.png" class="relx-logo" role="img" alt="relx logo">
        </li>
      </ul>
    </div>
  </div>
</footer>

